import React from 'react';
import { View } from 'react-native';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { useRoute, RouteProp, useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';
import { useTranslation } from 'react-i18next';
import { AppBar } from '@ui';
import { useTheme } from '@theme/ThemeProvider';
import { RootStackParamList, JourneyTopTabParamList } from '@navigation/types';

// Journey tab screens
import JourneyOverviewTab from './journey/JourneyOverviewTab';
import JourneyChecklistsTab from './journey/JourneyChecklistsTab';
import JourneyClinicsTab from './journey/JourneyClinicsTab';
import JourneyKeepsakesTab from './journey/JourneyKeepsakesTab';

const Tab = createMaterialTopTabNavigator<JourneyTopTabParamList>();

const Container = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
`;

type JourneyDetailRouteProp = RouteProp<RootStackParamList, 'JourneyDetail'>;

const JourneyDetailScreen: React.FC = () => {
  const { t } = useTranslation();
  const route = useRoute<JourneyDetailRouteProp>();
  const navigation = useNavigation();
  const theme = useTheme();
  const { journeyId } = route.params;

  return (
    <Container>
      <AppBar
        title={t('journey.newMom.title')}
        leftIcon="arrow-back"
        onLeftPress={() => navigation.goBack()}
      />
      <Tab.Navigator
        screenOptions={{
          tabBarActiveTintColor: theme.colors.brandPrimary,
          tabBarInactiveTintColor: theme.colors.textSecondary,
          tabBarPressColor: `${theme.colors.brandPrimary}15`,
          tabBarIndicatorStyle: {
            backgroundColor: theme.colors.brandPrimary,
            height: 4,
          },
          tabBarLabelStyle: {
            fontSize: theme.typography.bodyMedium.fontSize,
            fontWeight: theme.typography.titleMedium.fontWeight,
            textTransform: 'none',
            letterSpacing: 0,
          },
          tabBarStyle: {
            backgroundColor: theme.colors.surface,
            elevation: 0,
            shadowOpacity: 0,
            borderBottomWidth: 1,
            borderBottomColor: theme.colors.border,
            paddingHorizontal: theme.spacing.xs,
          },
          tabBarItemStyle: {
            paddingVertical: theme.spacing.sm,
          },
          tabBarScrollEnabled: true,
        }}
      >
        <Tab.Screen
          name="Overview"
          component={JourneyOverviewTab}
          initialParams={{ journeyId }}
          options={{ title: t('journey.newMom.overview') }}
        />
        <Tab.Screen
          name="Checklists"
          component={JourneyChecklistsTab}
          initialParams={{ journeyId }}
          options={{ title: t('journey.newMom.checklists') }}
        />
        <Tab.Screen
          name="Clinics"
          component={JourneyClinicsTab}
          initialParams={{ journeyId }}
          options={{ title: t('journey.newMom.clinics') }}
        />
        <Tab.Screen
          name="Keepsakes"
          component={JourneyKeepsakesTab}
          initialParams={{ journeyId }}
          options={{ title: t('journey.newMom.keepsakes') }}
        />
      </Tab.Navigator>
    </Container>
  );
};

export default JourneyDetailScreen;
